/** @format */

import { LoggerLevel } from '../enums/logger-level.enum';

export class LoggerConfig {
	clientLoggerLevel: LoggerLevel;
	xhrLoggerLevel: LoggerLevel;
	xhrLoggerUrl: string;
}
